import React, { Fragment } from "react";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { validOrZero } from "../../../../utils/utils";
import { KeyValBox } from "../../../../libraries/ReportGenerator/KeyValBox";
import { TickBox } from "../../../../libraries/ReportGenerator/TickBox";
import { getCustomerAbbr } from "../../../MainPage/VersionInfo";

let conditions = ["wet", "foul", "standing", "flooded", "tie", "uComm"];
let conditionsCapital = ["Wet", "Foul Ballast", "Standing water", "Flooded", "Compromised Tie or Ties", "Other"];
const AssetAreaConditionSchema = [
  {
    heights: { header1: "auto", header2: "auto" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Asset Area Condition",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        centerAlign: true,
      },
    ],
  },
  {
    heights: { header1: "" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Area Condition",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        centerAlign: true,
      },
      {
        title: "Comments",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        centerAlign: true,
      },
    ],
  },
  {
    heights: { header1: "" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Condition",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: conditions,
        isValueOnly: true,
        dontJoinValues: true,
        formatter: (values) => {
          return conditionsCapital.map((label, index) => (
            <TickBox
              flag={values && values[index]}
              label={label}
              style={{ marginLeft: "20px" }}
              otherStyle={{ textTransform: "capitalize" }}
              skipOtherUnderline={true}
            />
          ));
        },
      },
      {
        isValueOnly: true,
        title: "Comments",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "comm",
        centerAlign: true,
      },
    ],
  },
];
const AssetAreaCondition = (props) => {
  let { data } = props;
  if (!data || data.length === 0) return null;
  let lastData = (data || []).at(-1);
  let isPATH = getCustomerAbbr() === "PATH";

  let getProcessedSummary = (summary) => {
    let obj = {};
    for (let key in summary) {
      if (key === "wet" || key === "Wet") obj.wet = summary[key];
      if (key === "foul" || key === "Foul Ballast") obj.foul = summary[key];
      if (key === "standing" || key === "Standing water") obj.standing = summary[key];
      if (key === "flooded" || key === "Flooded") obj.flooded = summary[key];
      if (key === "tie" || key === "Compromised Tie or Ties") obj.tie = summary[key];
      if (key === "uComm" || key === "Other") obj.uComm = summary[key];
      if (key === "comm" || key === "Comments") obj.comm = summary[key];
    }
    return obj;
  };
  return (
    <table className="table-bordered" style={{ fontSize: "20px" }}>
      <ReportTableSectionRenderer rowsData={{}} section={AssetAreaConditionSchema[0]} />
      <ReportTableSectionRenderer rowsData={{}} section={AssetAreaConditionSchema[1]} />
      <ReportTableSectionRenderer rowsData={getProcessedSummary(lastData.summary)} section={AssetAreaConditionSchema[2]} />
    </table>
  );
};

export default AssetAreaCondition;



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/AssetAreaConditionReport/index.jsx